import { render } from "./SelectBox.vue?vue&type=template&id=4a647d7e&scoped=true&ts=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"

import "./SelectBox.vue?vue&type=style&index=0&id=4a647d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a647d7e"]])

export default __exports__